export function applyThemeToRoot(shades){
    const root=document.documentElement;
    Object.keys(shades.primary ||{}).forEach(key=>{
        root.style.setProperty(`--ava-color-primary-${key}`,shades.primary[key])
    })
    Object.keys(shades.secondary ||{}).forEach(key=>{
        root.style.setProperty(`--ava-color-secondary-${key}`,shades.secondary[key])
    } 
)
}